
(function ($) {

    $('.workbook-area .panel .header').click(function (e) {
        console.log('test');
        if($(e.target).is('a')){
            return true;
        }

        if(($(this).closest('.panel').find('.body').is(":hidden"))){
            $('.panel').removeClass('active');
            $(this).closest('.panel').addClass('active');
        } else{
            $(this).closest('.panel').removeClass('active');
        }

    });


})(jQuery);